import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    driverNoteDrawerWrapper: {
        backgroundColor: 'white',
        // padding: theme.spacing(4),
    },
    titleWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 1, 1, 1),
        backgroundColor: 'rgb(251, 251, 251)',
        '-webkit-box-shadow': '0 4px 6px -6px black',
    },
    titleWrapperForDriver:{
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(1, 1, 1, 1),
        backgroundColor: 'rgb(251, 251, 251)',
        '-webkit-box-shadow': '0 4px 6px -6px black',
    },
    title:{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        margin: theme.spacing(0, 0, 0, 2),
    },  
    shareWithDriverWrapper:{
        display: 'flex',
        alignItems: 'center',
        // cursor: 'pointer',
    }, 
    addNewNote: {
        fontSize: 12,
        fontWeight: 500,
        color: 'rgb(0, 0, 0)',
        alignSelf: 'center',
        marginTop:'3px',
        marginLeft:'8px'
    },
    closeButton: {
        // height: theme.spacing(3),
        // width: theme.spacing(3),
        marginLeft: theme.spacing(1),
        // color: theme.palette.grey[500],
        cursor: 'pointer'
    },
    mainContent: {
        // display: 'flex',
        // height: '400px',
        justifyContent: "right"
    },
    leftPanel: {
        width: '40%',
        // padding: theme.spacing(1, 0, 1, 1),
        float: 'left',
        backgroundColor: 'rgb(250, 250, 250)',
        // height:'100%',
        height: 'calc( 100vh - 65px )',
        marginTop:theme.spacing(0.5)
    },
    rightPanel: {
        display: 'flex',
        flexDirection: 'column',
        // backgroundColor: 'rgb(251, 251, 251)'
        height: 'calc( 100vh - 65px )',
    },
    noteItemRow: {
        // display: 'flex',
        // alignItems: 'center',
        cursor: 'pointer',
        // background: 'rgb(255, 250, 229)',
        height: theme.spacing(9),
        // paddingLeft: 12,
    },
    noteItemRowSelected: {
        // display: 'flex',
        // alignItems: 'center',
        cursor: 'pointer',
        background: 'rgb(255, 250, 229)',
        height: theme.spacing(9.2),
        // paddingLeft: 12,
        border:'1px solid rgba(249, 208, 55)',       
    },
    noteItem:{
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 2, 1, 2),
        height:theme.spacing(9),
        alignItems: 'center',
    },
    readTag:{
        backgroundColor: 'rgba(251, 35, 64)',
        margin: "0px 0px 8px -17px",
        width: "28px",
        height:'4px'
    },
    noteDesc:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        // alignSelf: 'flex-start',
        // width: '40%',
    },
    noteText: {
        fontSize: 12,
        color: 'rgba(0, 0, 0)',
        fontWeight: 500,
        // width: '80%',
        maxWidth: '200px',
        // lineClamp:1,
        'WebkitLineClamp': 3,
        // display: '-webkit-box',
        boxSizing:'border-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding:theme.spacing(0,0,0.5,0)
    },
    noteDate: {
        fontSize: 10,
        color: 'rgba(163, 171, 182)',
        fontWeight: 300,
        // width: '80%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding:theme.spacing(0.5,0,0,0)
    },
    noteDate1: {
        fontSize: 12,
        color: 'rgba(163, 171, 182)',
        fontWeight: 400,
        // width: '80%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding:theme.spacing(3, 0, 2, 0),
    },
    share:{
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-end',
        // alignSelf: 'flex-start',
        // width: '40%',
    },
    shareIcon:{
        backgroundColor:'rgba(239, 239, 239)',
        borderRadius:theme.spacing(1.5),
        padding:theme.spacing(0.5),
        marginBottom:theme.spacing(0.75)
    },
    shareIconYellow:{
        backgroundColor:'rgba(255, 212, 40)',
        borderRadius:theme.spacing(1.5),
        padding:theme.spacing(0.5),
        marginBottom:theme.spacing(0.75)
    },
    noteContent:{
        fontSize: 12,
        color: 'rgba(0, 0, 0)',
        padding:theme.spacing(1, 1, 1, 1)
    },
    loadingContainer: {
        padding: "1.6em",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor:'rgba(250, 250, 250)'
    },
    userInput: {
        width: 400,
        margin: theme.spacing(0, 0, 0, 0),
        // height: 'calc( 100vh - 65px )',
        "& .MuiInputLabel-root": {
            transform: "translate(0, 1.5px) scale(1)",
            fontSize: 15,
            fontWeight: 400,
            color: "#000",
        },
        "& .MuiInputBase-root": {
            height: '800px',
            border: '0px none',
            backgroundColor:"white",
            width:'100%'
        },
        "& .MuiInputBase-input": {
            // padding: `14px 10px`,
            color: 'rgb(0, 0, 0)',
            height: '800px',
        },
        "& .MuiFormHelperText-root":{
            alignItems:'flex-start',
            transformOrigin: 'left top' 
        }
    },
    deleteDialog: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 1, 1, 1),
        backgroundColor: 'rgb(255, 226, 226)',
        '-webkit-box-shadow': '0 4px 6px -6px black',
        alignItems:'center'
    },
    deleteDialogText:{
        fontSize: 12,
        color: 'rgba(0, 0, 0)',
        fontWeight: 500,
    },
    deleteButtonContainer:{
        display: 'flex',
        justifyContent: 'space-between',
        // padding: theme.spacing(1, 1, 1, 1),
        alignItems:'center'
    },
    deleteButton:{
        color:'rgba(255, 255, 255)',
        backgroundColor:'rgba(227, 65, 65)',
        padding:theme.spacing(2, 3, 2, 3),
        height:'30px'
    },
    deleteCloseButton: {
        marginLeft: theme.spacing(1),
        cursor: 'pointer'
    },
}));